"use client"

import { useNavigate } from 'react-router-dom'
import { useAuth, useLogout } from '@/lib/api'
import { showToast } from '@/lib/toast'
import { Loader } from '@/components/ui/Loader'

const Welcome = () => {
  const navigate = useNavigate()
  const { user } = useAuth()
  const logoutMutation = useLogout()

  const handleNewsRoomClick = () => {
    showToast.info('Coming soon')
  }

  const handleWebsiteContentClick = () => {
    navigate('/admin/dashboard')
  }

  const handleSignOut = () => {
    logoutMutation.mutate(undefined, {
      onSuccess: () => {
        navigate('/login')
      },
      onError: () => {
     
        navigate('/login')
      }
    })
  }

  return (
    <div
      className="min-h-screen relative bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url('https://res.cloudinary.com/dlwegkhme/image/upload/v1758276306/4566fdb7d627725b2d38f7ee63b5325d353e3957_dfuanb.png')`
      }}
    >

      <div className="absolute inset-0 bg-black opacity-80"></div>


      <div className="relative z-10 p-4 sm:p-8 bg-white">
        <div className="flex justify-between items-center">
          {/* Sign out button on the left */}
          <button
            onClick={handleSignOut}
            disabled={logoutMutation.isPending}
            className="flex items-center space-x-1 sm:space-x-2 text-black hover:text-gray-800 transition-colors disabled:opacity-50"
          >
            {logoutMutation.isPending ? (
              <Loader size="xs" variant="wine" className="border-black" />
            ) : (
              <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
            )}
            <span className="font-satoshi text-sm sm:text-base">{logoutMutation.isPending ? 'Signing Out...' : 'Sign Out'}</span>
          </button>

          {/* User info on the right */}
          <div className="flex items-center space-x-2 sm:space-x-3">
            <div className="text-xs sm:text-sm text-right hidden sm:block">
              <div className="font-medium font-satoshi">Account</div>
              <div className="text-gray-800 font-satoshi">{user?.userProfile.emailAddress || 'test@gmail.com'}</div>
            </div>
            <div className="w-6 h-6 sm:w-8 sm:h-8 bg-gray-600 rounded-full flex items-center justify-center">
              <span className="text-xs sm:text-sm font-medium font-satoshi text-white">
                {user?.userProfile.emailAddress?.charAt(0).toUpperCase() || 'U'}
              </span>
            </div>
          </div>
        </div>
      </div>


      <div className="relative z-10 flex items-center justify-center min-h-[calc(100vh-120px)] px-4 sm:px-8">
        <div className="w-full max-w-2xl bg-white rounded-lg shadow-2xl overflow-hidden">
  
          <div className="relative">
            <img
              src="/top-frame.png"
              alt=""
              className="w-full h-auto object-cover"
            />
          </div>

     
          <div className="p-4 sm:p-8 text-center">

            <div className="mb-6 sm:mb-8">
              <img
                className="h-12 sm:h-16 w-auto mx-auto"
                src='https://res.cloudinary.com/dlwegkhme/image/upload/v1755760984/LOGO_AFSA_o4r8px.png'
                alt="AFSA logo"
              />
            </div>


            <div className="mb-6 sm:mb-8">
              <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-2 font-satoshi">
                Welcome to Africa Space Agency
              </h1>
              <p className="text-sm sm:text-base text-gray-600 font-satoshi">
                Select what you'd like to do first, you can always select another option
              </p>
            </div>

     
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          
              <button
                onClick={handleNewsRoomClick}
                className="group bg-gray-50 hover:bg-forestGreen-100 rounded-lg p-4 sm:p-6 transition-all duration-200 border border-gray-200 hover:border-forestGreen-100"
              >
                <div className="flex flex-col space-y-3 sm:space-y-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-imageBg-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                    <img src="/newsroom-icon.png" 
                    alt="News Room" 
                    className="w-5 h-5 md:w-7 md:h-7 object-contain"
                     />
                  </div>
                  <span className="text-base sm:text-lg font-medium text-gray-900 group-hover:text-white font-satoshi text-left transition-colors">
                    News Room
                  </span>
                </div>
              </button>


              <button
                onClick={handleWebsiteContentClick}
                className="group bg-gray-50 hover:bg-forestGreen-100 rounded-lg p-4 sm:p-6 transition-all duration-200 border border-gray-200 hover:border-forestGreen-100"
              >
                <div className="flex flex-col space-y-3 sm:space-y-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-imageBg-100 rounded-full flex items-center justify-center group-hover:bg-green-200 transition-colors">
                    <img src="/websitecontent-icon.png" 
                    alt="Website Content" 
                    className="w-5 h-5 md:w-7 md:h-7 object-contain"
                     />
                  </div>
                  <span className="text-base sm:text-lg font-medium text-gray-900 group-hover:text-white font-satoshi text-left transition-colors">
                    Website Content
                  </span>
                </div>
              </button>
            </div>
          </div>

        
          <div className="relative">
            <img
              src="/buttom-frame.png"
              alt=""
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Welcome